<template>
  <md-dialog
    :md-active.sync="show"
    @md-opened="openDialog"
    @md-clicked-outside="closeDialog"
    @md-closed="closeDialog"
  >
    <md-dialog-title>Application Admins</md-dialog-title>
    <div
      class="md-layout md-dialog-content md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100"
    >
      <form class="md-layout-item md-small-size-80 md-size-100" v-if="add_list">
        <md-autocomplete :class="messageClass" v-model="selectedAdmin" :md-options="adminsOptions" @md-changed="adminSelected">
          <label>Admin</label>
          <template slot="md-autocomplete-item" slot-scope="{ item }">
            <md-highlight-text>{{ item }}</md-highlight-text>
          </template>

          <template slot="md-autocomplete-empty" slot-scope="{ term }">
            No Admin matching "{{ term }}" were found.
          </template>
          <span class="md-error">Admin is required</span>
        </md-autocomplete>
      </form>
      <md-list v-else style="margin-top: 16px; width: 100%">
        <md-subheader>List of admins for this application</md-subheader>
        <!--        <md-divider></md-divider>-->
        <div v-for="owner in owners" :key="owner.id">
          <md-list-item>
            <md-avatar class="md-avatar-icon md-medium md-primary">
              {{ (owner.username || '').charAt(0) }}
            </md-avatar>
            <div class="md-list-item-text">
              {{ owner.username || '' }}
            </div>
          </md-list-item>
          <md-divider></md-divider>
        </div>
      </md-list>
      <div class="md-layout-item md-size-100 text-right">
        <md-button @click="closeDialog">Close</md-button>
        <md-button class="md-primary" @click="addAdmin" v-if="add_list"
          >Add
        </md-button>
      </div>
    </div>
  </md-dialog>
</template>

<script>
import fetchErrorHandler from "../error";

export default {
  name: "ApplicationAdmins",
  props: ["show", "application_id", "add_list"],
  data: function() {
    return {
      owners: [],
      admins: [],
      selectedAdmin: null,
      showAddNew: false,
      hasMessages: false
    };
  },
  computed: {
    messageClass() {
      return {
        "md-invalid": this.hasMessages
      };
    },
    adminsOptions() {
      return this.admins.map((x) => ({
        username: x.username,
        id: x.id,
        toLowerCase: () => x.username.toLowerCase(),
        toString: () => x.username,
      }));
    },
  },
  methods: {
    closeDialog: function() {
      this.$emit("close");
      this.admins = [];
      this.owners = [];
    },
    openDialog: function() {
      this.selectedAdmin = "";
      this.getApplicationOwners();
      this.getApplicationAdmins();
    },
    getApplicationOwners: async function() {
      let url =
        this.$store.state.server_address +
        "api/v1/dashboard/application-admins/?application_pk=" +
        this.application_id;
      let headers = {
        Authorization: this.$store.getters.getAccessToken
      };
      let response = await fetch(url, {
        method: "GET",
        headers: headers
      });
      if (response.status !== 200) {
        fetchErrorHandler(
          response.status,
          response.statusText,
          this.$options.name
        );
      }
      let responseJson = await response.json();
      this.owners = responseJson.response.admins;
    },
    getApplicationAdmins: async function() {
      let url =
        this.$store.state.server_address +
        "api/v1/dashboard/available-admins/?application_pk=" +
        this.application_id;
      let headers = {
        Authorization: this.$store.getters.getAccessToken
      };
      let response = await fetch(url, {
        method: "GET",
        headers: headers
      });
      if (response.status !== 200) {
        fetchErrorHandler(
          response.status,
          response.statusText,
          this.$options.name
        );
      }
      let responseJson = await response.json();
      this.admins = responseJson.response.admins;
      console.warn(this.admins);
    },
    addAdmin: async function() {
      let url =
        this.$store.state.server_address +
        "api/v1/dashboard/application-admins/";
      let headers = {
        "Content-Type": "application/json",
        Authorization: this.$store.getters.getAccessToken
      };
      let data = {
        application_pk: this.application_id,
        application_admin_pk: this.selectedAdmin
      };
      if (!this.selectedAdmin) {
        this.hasMessages = true;
        return;
      }
      let response = await fetch(url, {
        headers: headers,
        method: "POST",
        body: JSON.stringify(data)
      });
      if (response.status === 401) {
        fetchErrorHandler(
          response.status,
          response.statusText,
          this.$options.name
        );
      }
      if (response.status === 200) {
        this.$notify({
          message: "Application admin successfully added to application",
          icon: "add_alert",
          horizontalAlign: "right",
          verticalAlign: "top",
          type: "success"
        });
        this.hasMessages = false;
        this.selectedAdmin = "";
        this.closeDialog();
      }
    },
    adminSelected(item) {
      this.selectedAdmin = item.id;
    },
  },
  mounted() {
    this.getApplicationOwners();
    this.getApplicationAdmins();
  }
};
</script>

<style scoped></style>
